import styled from 'styled-components';

export const StyledCompaniesListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
